import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './OrderPanel.module.css';
import { ModalInMobile } from '../../components';
import BookingDatesFormWithAvailability from './BookingDatesForm/BookingDatesFormWithAvailability';

import { propTypes } from '../../util/types';

const OrderPanel = props => {
  const {
    className = null,
    rootClassName = null,
    listing,
    title,
    unitType,
    price,
    bookingDates = null,
    timeSlots = null,
    monthlyTimeSlots = null,
    onSubmit,
    onFetchTimeSlots,
    fetchTimeSlotsError = null,
    onManageDisableScrolling = () => {}, // ✅ fallback to prevent crash
  } = props;

  const [isBookingDatesModalOpen, setIsBookingDatesModalOpen] = useState(false);

  const handleBookingDatesSubmit = values => {
    setIsBookingDatesModalOpen(false);
    onSubmit(values);
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <ModalInMobile
        isOpen={isBookingDatesModalOpen}
        onClose={() => setIsBookingDatesModalOpen(false)}
        contentLabel="Booking dates"
        onManageDisableScrolling={onManageDisableScrolling} // ✅ fixed
      >
        <BookingDatesFormWithAvailability
          listingId={listing.id.uuid}
          onSubmit={handleBookingDatesSubmit}
          onFetchTimeSlots={onFetchTimeSlots}
          fetchTimeSlotsError={fetchTimeSlotsError}
          timeSlots={timeSlots}
          monthlyTimeSlots={monthlyTimeSlots}
        />
      </ModalInMobile>

      <div className={css.orderDetails}>
        <h2>{title}</h2>
        {/* 🔧 Replace this with your OrderDetails component later */}
        <p>Booking info and selected items will appear here.</p>
      </div>
    </div>
  );
};

OrderPanel.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  listing: propTypes.listing.isRequired,
  title: PropTypes.string.isRequired,
  unitType: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  bookingDates: PropTypes.object,
  timeSlots: PropTypes.object,
  monthlyTimeSlots: PropTypes.object,
  fetchTimeSlotsError: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onFetchTimeSlots: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func,
};

export default OrderPanel;
